import { useEffect, useState } from "react";
import UserService from "src/Services/API/user.service";
import BranchDropDown from "src/Pages/Setting/Team/Invite/InviteModal/branchdropdown";

function AddModal({ branches, customer, onAddClicked, onUpateClicked, onCancelClicked }) {
  const currentUser = UserService.getCurrentUser();
  const [companyName, setCompanyName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [yesButtonTitle, setYesButtonTitle] = useState("ADD");
  const [branch, setBranch] = useState(null);
  const [contact, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (customer) {
      setCompanyName(customer.companyName);
      setPhone(customer.phone);
      setAddress(customer.address);
      setBranch(customer.branch);
      setContact(customer.contact);
      setEmail(customer.email);
      setYesButtonTitle("UPDATE");
    } else {
      setYesButtonTitle("ADD");
    }
  }, []);

  const addClicked = () => {
    setSubmitted(true);
    if (!companyName.trim() || !branch) return;

    if (customer) {
      customer.companyName = companyName;
      customer.phone = phone;
      customer.address = address;
      customer.branch = branch;
      customer.contact = contact;
      customer.email = email;
      onUpateClicked(customer);
    } else {
      const data = {
        companyName,
        phone,
        address,
        branch,
        contact,
        email,
      };
      onAddClicked(data);
    }
  };

  const cancelClicked = () => {
    onCancelClicked();
  };

  return (
    <div
      onClick={onCancelClicked}
      className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
    >
      <div onClick={(e) => e.stopPropagation()} className="w-[448px] bg-white rounded-[6px] p-[18px] flex flex-col">
        <p className="text-[16px] font-OpenSansMedium font-[600] text-titleColor mb-5">ADD CUSTOMER</p>

        <div className="flex flex-col justify-between h-full">
          <div className="h-[60px] w-full mb-2">
            <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">Company</p>
            <div className={`w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center justify-center px-[15px] ${submitted && !companyName.trim() ? "border-red-500" : ""}`}>
              <input
                value={companyName}
                type="text"
                onChange={(e) => setCompanyName(e.target.value)}
                className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
                placeholder="Enter company name"
              />
            </div>
          </div>
          <div className="h-[60px] w-full mb-2">
            <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">Phone Number</p>
            <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center justify-center px-[15px]">
              <input
                value={phone}
                type="text"
                onChange={(e) => setPhone(e.target.value)}
                className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
                placeholder="(xx) xxxx-xxxx"
              />
            </div>
          </div>

          <div className="h-[60px] w-full mb-2">
            <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">Address</p>
            <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center justify-center px-[15px]">
              <input
                value={address}
                type="text"
                onChange={(e) => setAddress(e.target.value)}
                className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
                placeholder="Enter Address"
              />
            </div>
          </div>

          <div className="h-[60px] w-full mb-2">
            <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">Contact Name</p>
            <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center justify-center px-[15px]">
              <input
                value={contact}
                type="text"
                onChange={(e) => setContact(e.target.value)}
                className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
                placeholder="Enter contact name"
              />
            </div>
          </div>

          <div className="h-[60px] w-full mb-2">
            <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">Email Address</p>
            <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center justify-center px-[15px]">
              <input
                value={email}
                type="email"
                onChange={(e) => setEmail(e.target.value)}
                className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
                placeholder="Enter email address"
              />
            </div>
          </div>

          <div className="h-[60px] w-full mb-2">
            <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">Branch</p>
            <div className={`w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center justify-center ${submitted && !branch ? "border-red-500" : ""}`}>
              <BranchDropDown branches={branches} selectedBranch={branch} branchClicked={setBranch} />
            </div>
          </div>

          <div className=" w-full">
            <div className="flex items-center justify-between gap-4">
              <div
                onClick={cancelClicked}
                className="w-[50%] h-[30px] text-[10px] rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor cursor-pointer"
              >
                CANCEL
              </div>
              <div
                onClick={addClicked}
                className="w-[50%] h-[30px] text-[10px] rounded-[6px] flex items-center justify-center bg-blueColor text-white cursor-pointer"
              >
                {yesButtonTitle}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddModal;
